import '../../../polyfills';
import WebpackerReact from 'webpacker-react';

import { MembershipPlanCards } from '../../../MembershipPlanCards';
import { MembershipPlanCardsOld } from '../../../MembershipPlanCardsOld';

WebpackerReact.setup({
  MembershipPlanCards,
  MembershipPlanCardsOld,
});
